var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g(_vm._b({ref:"self",staticClass:"irisv-sheet__scrim",attrs:{"id":_vm.identifier_},on:{"click":function($event){return _vm.$emit('scrim-click', false)}}},'div',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }